module.exports = __webpack_public_path__ + "static/media/chart-bar-secondary4.052ef6a3.svg";